import * as action from "../reducers/pageReducer";
import axios, { authHeader } from "../../services/HTTPService";
const API_URL = process.env.REACT_APP_API_URL;

export const fetchAll = async (
  dispatch,
  {
    fieldTofilter,
    filter,
    fieldToSort,
    sortDirection,
    page,
    pageSize,
    member,
  } = {
    fieldTofilter: "title",
    filter: "",
    fieldToSort: "id",
    sortDirection: "asc",
    page: 1,
    pageSize: 8,
  }
) => {
  dispatch(action.setListLoading(true));

  return axios
    .get(API_URL + `/api/pages/backoffice/search`, {
      headers: authHeader(),
      params: {
        fieldTofilter,
        filter,
        fieldToSort,
        sortDirection,
        page,
        pageSize,
        member,
      },
    })
    .then(({ data }) => {
      const meta = data?.meta;
      dispatch(action.setPageList({ data }));
      dispatch(action.setMetadata({ meta }));
      dispatch(action.setListLoading(false));
    })
    .catch((error) => {
      dispatch(
        action.setPageError({ error: error?.response?.data?.error?.message })
      );
      dispatch(action.setListLoading(false));
    });
};

export const fetchDetails = async (dispatch, id) => {
  return axios
    .get(API_URL + `/api/pages/${id}`, { headers: authHeader() })
    .then(({ data }) => {
      dispatch(action.setPageDetail({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setPageError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const create = async (dispatch, body) => {
  return axios
    .post(API_URL + "/api/pages", body, { headers: authHeader() })
    .then(({ data }) => {
      dispatch(action.setPage({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setPageError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const update = async (dispatch, id, body) => {
  return axios
    .put(API_URL + `/api/pages/${id}`, body, { headers: authHeader() })
    .then(({ data }) => {
      dispatch(action.setPage({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setPageError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const remove = async (dispatch, id, params) => {
  return axios
    .delete(API_URL + `/api/pages/${id}`, { headers: authHeader() })
    .then(async () => {
      await fetchAll(dispatch, params);
    })
    .catch((error) => {
      dispatch(
        action.setPageError({ error: error?.response?.data?.error?.message })
      );
    });
};
